

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

export enum TooltipColor {
  Primary = 'tooltip--primary',
  Secondary = 'tooltip--secondary',
  BlueDark = 'tooltip--blue-dark',
  GreyDark = 'tooltip--grey-dark',
  Gold = 'tooltip--gold',
  GoldDark = 'tooltip--gold-dark',
  Red = 'tooltip--red',
  Pink = 'tooltip--pink',
  Orange = 'tooltip--orange',
}

export enum TooltipAlign {
  Center = 'tooltip--align-center',
  Left = 'tooltip--align-left',
}

@Component({
  computed: {
    ...mapGetters ({
      isOpenNavbar: 'isOpenNavbar',
    }),
  },
})
export default class Tooltip extends Vue {
    @Prop() private title!: string;
    @Prop({ default: TooltipColor.BlueDark }) private color!: TooltipColor;
    @Prop({ default: TooltipAlign.Center }) private align!: TooltipAlign;
    @Prop({ default: false }) private disabled!: boolean;

    private isShow: boolean = false;
    private isShowTimeout!: any;
    private enterPosition: boolean = true;
    private isOpenNavbar!: boolean;
    private isHover: boolean = false;

    @Watch('disabled')
    private watchDisabled(newVal: boolean, oldVal: boolean) {
      if (!newVal && this.isHover) {
        this.mouseOver();
      }
    }

    private updated() {
      if ( this.isShow ) {
        this.positionTooltip();
      }
    }

    private mouseOver() {
      this.isHover = true;
      this.$emit('mouseenter');
      if (!this.disabled) {
        this.isShowTimeout = setTimeout( () => {
          this.isShow = true;
          Vue.nextTick( () => {
            if (this.enterPosition) {
              this.positionTooltip();
            }
          } );
        }, 500);
      }
    }

    private mouseLeave() {
      this.isHover = false;
      if ( !this.isShow && this.isShowTimeout ) {
        window.clearTimeout( this.isShowTimeout );
      }
      this.isShowTimeout = setTimeout( () => {
        this.isShow = false;
        this.enterPosition = true;
        const tooltipElement = (this.$refs.tooltipElement as HTMLFormElement);
        if ( tooltipElement ) {
          tooltipElement.style.opacity = '0';
        }
      }, 500);
    }

    private positionTooltip() {
      this.enterPosition = false;
      const tooltipElement = (this.$refs.tooltipElement as HTMLFormElement);
      const tooltipParent = (this.$refs.tooltipParent as HTMLFormElement);
      const tooltipCorner = (this.$refs.tooltipCorner as HTMLFormElement);
      const widthScreen = document.body.offsetWidth;
      const margin = 0;
      const mainNavBarNode = document.getElementsByClassName('main-nav-bar')[0];
      let mainNavBarWidth = 0;
      if ( mainNavBarNode ) {
        mainNavBarWidth = parseInt(window.getComputedStyle(mainNavBarNode, null).getPropertyValue('width'), 10);
      }

      if (
        tooltipElement && tooltipParent && tooltipCorner &&
        tooltipElement.getBoundingClientRect().right !== 0
      ) {
        // Position left and rigth
        const centerParentTooltip = (tooltipParent.offsetWidth / 2);
        let centerTooltip = (tooltipElement.offsetWidth / 2);
        centerTooltip = centerParentTooltip - centerTooltip;
        tooltipElement.style.left = centerTooltip + 'px';
        tooltipElement.style.right = 'unset';
        const rigthPositionTooltip = tooltipElement.getBoundingClientRect().right;
        const leftPositionTooltip = tooltipElement.getBoundingClientRect().left;
        if (rigthPositionTooltip >= (widthScreen - margin)) {
          tooltipElement.style.right = '-16px';
          tooltipElement.style.left = 'unset';
        } else if (leftPositionTooltip <= (mainNavBarWidth + margin)) {
          tooltipElement.style.left = '-16px';
          tooltipElement.style.right = 'unset';
        } else {
          const centerParentTooltip = (tooltipParent.offsetWidth / 2);
          let centerTooltip = (tooltipElement.offsetWidth / 2);
          centerTooltip = centerParentTooltip - centerTooltip;
          tooltipElement.style.left = centerTooltip + 'px';
          tooltipElement.style.right = 'unset';
        }

        // Position corner
        let centerCorner = (tooltipParent.offsetWidth / 2) - 4;
        if (tooltipElement.getBoundingClientRect().left < tooltipParent.getBoundingClientRect().left) {
          centerCorner += tooltipParent.getBoundingClientRect().left - tooltipElement.getBoundingClientRect().left;
        }
        tooltipCorner.style.left = centerCorner + 'px';
        tooltipElement.style.opacity = '1';
      }
    }
}
